export class DateFilterModel {
    dataType: string;
    displayName: string;
    fieldName: string;
    startDate: Date;
    startTime: string;
    endDate: Date;
    endTime: string;
    dateRange: string;
    isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker-list/date-filter.model.ts